import { PatcherSet } from "./patcher";
import ldj01020240325 from "./patcher/patchsets/ldj-010-20240325";
import ldj01020240507 from "./patcher/patchsets/ldj-010-20240507";
import ldj01220240702 from './patcher/patchsets/ldj-012-20240702';

export function genPatches() {
    const patches = [{
        name: 'LDJ-65fbdb9b_a29c4c.json',
        dateCode: 20240325,
        patchset: ldj01020240325,
    }, {
        name: 'LDJ-662a05c7_a5bf9c.json',
        dateCode: 20240507,
        patchset: ldj01020240507,
    }, {
        name: 'LDJ-667bbdca_9a798c.json',
        dateCode: 20240702,
        patchset: ldj01220240702,
    }];

    for (const patch of patches) {
        const patcher = new PatcherSet('bm2dx.dll', 'ldj', patch.dateCode, '', patch.patchset);
        patcher.exportPatches2X(patch.name);
    }
}
